var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgTriangulos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.051,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00537109 249.693L249.698 0L499.391 249.693L249.698 499.386L0.00537109 249.693Z",
    fill: "#FF7D42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.051,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8667 249.527L249.631 27.7622L471.395 249.527L249.631 471.291L27.8667 249.527Z",
    fill: "#FF7D42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.051,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8457 249.379L249.483 53.7407L445.121 249.379L249.483 445.016L53.8457 249.379Z",
    fill: "#FF7D42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.051,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2012 249.607L249.712 80.0962L419.224 249.607L249.712 419.12L80.2012 249.607Z",
    fill: "#FF7D42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.051,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.686 249.615L249.72 107.581L391.754 249.615L249.72 391.649L107.686 249.615Z",
    fill: "#FF7D42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.051,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.43 249.629L249.734 137.325L362.038 249.629L249.734 361.934L137.43 249.629Z",
    fill: "#FF7D42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.051,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.927 249.495L249.6 167.822L331.273 249.495L249.6 331.169L167.927 249.495Z",
    fill: "#FF7D42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 249.69L249.691 200L299.382 249.69L249.691 299.381L200 249.69Z",
    fill: "#FF7D42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250 230.5C240.93 230.5 233.5 237.93 233.5 247V256C233.5 257.939 234.766 259.592 236.5 260.219V260.5C236.5 264.619 239.881 268 244 268H245.922C246.443 268.896 247.393 269.5 248.5 269.5H251.5C253.152 269.5 254.5 268.152 254.5 266.5C254.5 264.848 253.152 263.5 251.5 263.5H248.5C247.393 263.5 246.443 264.104 245.922 265H244C241.516 265 239.5 262.984 239.5 260.5H242.5V247H236.5C236.5 239.57 242.57 233.5 250 233.5C257.43 233.5 263.5 239.57 263.5 247H257.5V260.5H262C264.467 260.5 266.5 258.467 266.5 256V247C266.5 237.93 259.07 230.5 250 230.5ZM236.5 250H239.5V257.5H238C237.168 257.5 236.5 256.832 236.5 256V250ZM260.5 250H263.5V256C263.5 256.832 262.832 257.5 262 257.5H260.5V250Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTriangulos);
export default __webpack_public_path__ + "static/media/bg_triangulos.6716aba25416283bef11a0140a37c94a.svg";
export { ForwardRef as ReactComponent };